import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { BASEURL } from '../constant/url';
import { Client, ClientAttributes, Clients } from '../interfaces/client';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private readonly _http = inject(HttpClient);

  fetchClients(page: number, pageSize?: number, query?: string): Observable<Clients> {
    let url = `${BASEURL}clients?sort=id:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize || 10}`;
    if (query) {
      url += `&filters[$or][0][name][$containsi]=${encodeURIComponent(query)}&filters[$or][1][email][$containsi]=${encodeURIComponent(query)}`;
    }
    return this._http.get<Clients>(url).pipe(catchError(this.handleError));
  }

  getAll(): Observable<Clients> {
    return this._http.get<Clients>(BASEURL + 'clients?sort=id:desc&pagination[pageSize]=100').pipe(catchError(this.handleError));
  }

  searchClients(query: string = ''): Observable<Clients> {
    let url = BASEURL + 'clients?sort=id:desc&pagination[pageSize]=25';
    if (query) {
      url += `&filters[name][$containsi]=${encodeURIComponent(query)}`;
    }
    return this._http.get<Clients>(url).pipe(catchError(this.handleError));
  }

  fetchClient(id: number): Observable<Client> {
    return this._http
      .get<Client>(
        `${BASEURL}clients/${id}?populate=[agent]=*&populate[contact_people]=*&populate[budgets]=*&populate[services]=*&populate[notes][populate]=users_permissions_user`
      )
      .pipe(
        map((response: Client) => response.data),
        catchError(this.handleError)
      );
  }

  addClient(data: Client): Observable<Client> {
    return this._http.post<Client>(`${BASEURL}clients`, { data }).pipe(catchError(this.handleError));
  }

  updateClient(id: number, data: any): Observable<Client> {
    return this._http
      .put<Client>(`${BASEURL}clients/${id}?populate=*`, {
        data,
      })
      .pipe(
        map((response: Client) => response.data),
        catchError(this.handleError)
      );
  }

  deleteClient(id: number): Observable<any> {
    return this._http.delete<any>(`${BASEURL}clients/${id}`).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Error en el servicio de Clientes.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('ClientService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
